import api from "../../../../../services/api";

/**
 * Fetch public form structure and access token
 */
export const fetchPublicForm = async (publicId: string) => {
  try {
    const response = await api.post("/leadService/public/forms/list", {
      public_id: publicId,
    });

    if (response.data?.data) {
      return response.data.data;
    } else {
      throw new Error(response.data?.message || "Failed to fetch form");
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      error.message ||
      "Failed to load form";

    throw new Error(errorMessage);
  }
};

/**
 * Submit public form data
 */
export const submitPublicForm = async (
  publicId: string,
  accessToken: string,
  formData: { [key: string]: any }
) => {
  try {
    const response = await api.post("/leadService/public/forms/submission", {
      public_id: publicId,
      access_token: accessToken,
      form_data: formData,
    });

    if (response.data?.data) {
      return response.data.data;
    } else {
      throw new Error(response.data?.message || "Failed to submit form");
    }
  } catch (error: any) {
    const errorData = error?.response?.data || error?.data || {};
    const errorMessage =
      errorData?.message || error.message || "Failed to submit form";

    // Create enhanced error object
    const enhancedError: any = new Error(errorMessage);

    // Include validation errors if present
    if (errorData.errors) {
      enhancedError.errors = errorData.errors;
    }
    if (errorData.missing_fields) {
      enhancedError.missing_fields = errorData.missing_fields;
    }
    if (errorData.extra_fields) {
      enhancedError.extra_fields = errorData.extra_fields;
    }

    throw enhancedError;
  }
};

/**
 * Fetch locations data
 */
export const fetchLocationData = async (publicId: string) => {
  try {
    const response = await api.post(
      "/leadService/public/forms/getLocationsData",
      {
        public_id: publicId,
      }
    );

    return {
      countries: response.data.data.countries || [],
      states: response.data.data.states || [],
      cities: response.data.data.citites || [],
      districts: response.data.data.districts || [],
    };
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      error.message ||
      "Failed to load locations";

    throw new Error(errorMessage);
  }
};
